import { Controller } from '@hotwired/stimulus'

// Flowbite の Accordion（data-accordion="collapse"）を置き換える実装
// （issue #2203 脱Flowbite、Accordion移行）。
//
// Flowbite本体はまだ削除されておらず（Phase 5 #2249 待ち）、
// document.querySelectorAll('[data-accordion]') でコンテナ要素を
// グローバルスキャンして初期化する。コンテナの data-accordion 属性
// そのものを data-controller に置き換えて無くすことで、Flowbite側の
// スキャン対象から外れ、内側の data-accordion-target / data-accordion-icon
// はそのまま残しても二重初期化にならない（Flowbiteはコンテナ発見時のみ
// 内側をquerySelectorAllするため）。
//
// data-accordion-target の値（例: "#accordion-flush-body-xxx"）は
// Flowbite同様にCSSセレクタ文字列としてそのまま使う。alwaysOpen（"open"指定時に
// 複数展開可能にする）は本アプリで使用実績が無いため、常にFlowbiteの
// デフォルト（1つ開くと他を閉じる）と同じ挙動にしている。
export default class extends Controller {
  static values = {
    activeClasses: { type: String, default: 'bg-white dark:bg-gray-900 text-gray-900 dark:text-white' },
    inactiveClasses: { type: String, default: 'text-gray-500 dark:text-gray-400' },
  }

  connect() {
    this.activeClassList = this.activeClassesValue.split(/\s+/).filter(Boolean)
    this.inactiveClassList = this.inactiveClassesValue.split(/\s+/).filter(Boolean)
  }

  toggle(event) {
    const trigger = event.currentTarget
    const isOpen = trigger.getAttribute('aria-expanded') === 'true'

    if (isOpen) {
      this.close(trigger)
    } else {
      this.triggers().forEach((t) => {
        if (t !== trigger) this.close(t)
      })
      this.open(trigger)
    }
  }

  triggers() {
    return Array.from(this.element.querySelectorAll('[data-accordion-target]'))
  }

  panelFor(trigger) {
    return document.querySelector(trigger.getAttribute('data-accordion-target'))
  }

  open(trigger) {
    const panel = this.panelFor(trigger)
    if (!panel) return

    trigger.classList.remove(...this.inactiveClassList)
    trigger.classList.add(...this.activeClassList)
    trigger.setAttribute('aria-expanded', 'true')
    panel.classList.remove('hidden')
    trigger.querySelector('[data-accordion-icon]')?.classList.add('rotate-180')
  }

  close(trigger) {
    const panel = this.panelFor(trigger)
    if (!panel) return

    trigger.classList.remove(...this.activeClassList)
    trigger.classList.add(...this.inactiveClassList)
    trigger.setAttribute('aria-expanded', 'false')
    panel.classList.add('hidden')
    trigger.querySelector('[data-accordion-icon]')?.classList.remove('rotate-180')
  }
}
